import { IMAGE_BASE } from '../constants/site';
import {
  CONTACT_ADDRESS,
  CONTACT_EMAILS,
  CONTACT_PHONES,
  SOCIAL_GRID_LINKS,
} from '../constants/site';

export const CONTACT_DETAILS = [
  {
    id: 'email',
    icon: 'fa-solid fa-envelope',
    label: 'Email',
    lines: CONTACT_EMAILS,
  },
  {
    id: 'phone',
    icon: 'fa-solid fa-phone',
    label: 'Phone',
    lines: CONTACT_PHONES.map((phone) => `Tel: ${phone}`),
  },
  {
    id: 'address',
    icon: 'fa-solid fa-location-dot',
    label: 'Address',
    lines: [CONTACT_ADDRESS],
  },
];

export const PROJECT_UPDATES = [
  {
    title:
      'National Highway R11 km 0+000–km 59+300: Non Savan intersection to Pak Mi intersection',
    date: 'October 23, 2024',
    image: `${IMAGE_BASE}/img01.jpg`,
  },
  {
    images: [`${IMAGE_BASE}/img02.jpg`, `${IMAGE_BASE}/img04.jpg`],
  },
  {
    images: [`${IMAGE_BASE}/img06.jpg`, `${IMAGE_BASE}/img07.jpg`],
  },
  {
    images: [`${IMAGE_BASE}/img08.jpg`, `${IMAGE_BASE}/img09.jpg`],
  },
];

export const SOCIAL_LINKS = SOCIAL_GRID_LINKS;
